import React from 'react';
import { ClockIcon } from 'lucide-react';
import { PRICE } from '../data/content';
import { OfferCard } from './OfferCard';
export function OfferSection() {
  return <section id="comprar" aria-labelledby="oferta" className="scroll-mt-8 border-y border-ink-600 bg-ink-800" data-id="element-148" data-mp="3lzf5whesb6n">
      <div className="mx-auto max-w-4xl px-5 py-16 sm:py-20" style={{
      paddingTop: "14px",
      paddingBottom: "27px"
    }} data-id="element-149" data-mp="de56r53r0qlb">
        <div className="text-center" data-id="element-150" data-mp="ic6o9llj0huo">
          <p className="inline-flex items-center gap-2 rounded-full border border-court-400/40 bg-court-900/60 px-4 py-2 text-xs font-bold uppercase tracking-[0.2em] text-court-200" data-id="element-151" data-mp="ifb09558ghvw">
            <ClockIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-152" data-mp="refwu5x8i15f" />
            Precio de lanzamiento — por tiempo limitado
          </p>
          
          <p className="mx-auto mt-5 max-w-xl text-sm leading-relaxed text-slate-400" style={{
          paddingTop: "38px",
          marginTop: "-20px",
          marginBottom: "-20px"
        }} data-id="element-153" data-mp="2t5jbd6a8vzv9">
            Valor total del pack completo: <span className="text-slate-200 line-through" data-id="element-154" data-mp="12ojxmgef6anv">{PRICE.totalValue}</span>.
            Tu inversión hoy: <span className="font-bold text-ball-400" data-id="element-155" data-mp="xvqshrf1h0b9">{PRICE.today}</span>.
          </p>
        </div>

        <OfferCard className="mt-10" data-id="element-156" data-mp="syiabqtw4wa0" />
      </div>
    </section>;
}